//helper.js
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

export function displayError(errorMessage, title = "Error") {

  console.log("ERROR:", errorMessage);

  let msg = "";
  let code = "";

  // --- Normalize Error Message ---
  if (typeof errorMessage === "string") {
    msg = errorMessage;
  }
  else if (errorMessage?.message) {
    msg = errorMessage.message;
    code = errorMessage.code || "";
  }
  else if (typeof errorMessage?.detail === "string") {
    msg = errorMessage.detail;
  }
  else if (errorMessage?.detail?.message) {
    msg = errorMessage.detail.message;
    code = errorMessage.detail.code || errorMessage.code || "";
  }
  else if (!errorMessage) {
    msg = "Unable to reach server. Check API URL and backend status.";
  }
  else {
    msg = "Unexpected error occurred.";
  }

  let htmlContent = `<b><i>${msg}${code ? ` (Code: ${code})` : ""}</i></b>`;

  // --- Error Detail Handling ---
  const fieldErrors = Array.isArray(errorMessage?.errors)
    ? errorMessage.errors
    : (Array.isArray(errorMessage?.detail) ? errorMessage.detail : null);

  if (fieldErrors && fieldErrors.length > 0) {
    htmlContent += "<ul>";

    fieldErrors.forEach(detailItem => {
      htmlContent += "<li>";

      if (typeof detailItem === "string") {
        htmlContent += detailItem;
      } 
      else if (typeof detailItem === "object" && detailItem !== null) {
        Object.entries(detailItem).forEach(([key, value]) => {
          htmlContent += `<strong>${key}:</strong> ${value}<br>`;
        });
      }

      htmlContent += "</li>";
    });

    htmlContent += "</ul>";
  }



  // --- SweetAlert ---
  Swal.fire({
    title,
    html: htmlContent,
    icon: "error",
    customClass: {
      popup: "swal-wide",
    }
  });
}

export function getApiErrorMessage(error) {
  if (!error) {
    return 'Unexpected error occurred.';
  }
  if (typeof error === 'string') {
    return error;
  }
  const data = error.response?.data;
  if (typeof data === 'string') {
    return data;
  }
  if (typeof data?.detail === 'string') {
    return data.detail;
  }
  if (data?.message) {
    return data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'Unexpected error occurred.';
}

export function getLoginErrorMessage(error, apiBaseUrl = '') {
  if (!error?.response) {
    if (error?.code === 'ERR_NETWORK' || String(error?.message || '').includes('Network Error')) {
      const serverUrl = apiBaseUrl || 'the API server';
      return `Cannot connect to ${serverUrl}. Start the backend server and try again.`;
    }
    return error?.message || 'Unable to reach server. Check that the backend is running.';
  }

  const status = error.response.status;
  const data = error.response.data;
  const detail = typeof data?.detail === 'string'
    ? data.detail
    : (typeof data?.message === 'string' ? data.message : '');

  if (status === 401) {
    if (detail.toLowerCase().includes('otp')) {
      return detail || 'Incorrect OTP. Enter the current code from your authenticator app.';
    }
    return detail || 'Invalid username or password.';
  }
  if (status === 403) {
    return detail || 'Access denied. Your account validity may have expired or your IP is not allowed.';
  }
  if (status === 400) {
    if (detail.toLowerCase().includes('latitude') || detail.toLowerCase().includes('location')) {
      return `${detail} Enable browser location permission and refresh the page.`;
    }
    return detail || 'Login request is incomplete. Check username and password.';
  }

  return getApiErrorMessage(error);
}

export function isForbiddenError(error) {
  return error?.response?.status === 403;
}




export function displayErrorToast(titleMessage) {
  const snackbar = document.getElementById("snackbar");
  const icon = document.getElementById("snackbar-icon");
  const title = document.getElementById("snackbar-title");

  // ✅ Prevent crash if snackbar is not mounted
  if (!snackbar || !title) {
    console.warn("⚠️ Snackbar not found. Error:", titleMessage);
    return;
  }

  if (icon) {
    icon.src = "/error-icon.png";
    icon.height = 40;
    icon.width = 90;
  }

  title.innerText = titleMessage;

  snackbar.className = "show error";
  setTimeout(() => {
    snackbar.className = snackbar.className.replace("show", "");
  }, 3000);
}


export function displaySuccessToast(titleToast) {
  
    var snackbar = document.getElementById("snackbar");
    var icon =document.getElementById("snackbar-icon");
    icon.src= "./img/success-icon.png";
    icon.height = '50';
    icon.width = '40';
   // snackbar.style.height = '300px';
    var title = document.getElementById("snackbar-title");
    title.innerText = titleToast;
    snackbar.className = "show success";
    setTimeout(function(){ snackbar.className = snackbar.className.replace("show", ""); }, 3000);
      }
    
export function parseBoolean(booleanString) {

  return (booleanString && String(booleanString).toLowerCase() === 'true');
}    
export function parseBooleanToString(booleanValue){
  return (booleanValue?'Yes':'No');
}

export function mapUniqueSelectOptions(values) {
  const seen = new Set();
  const options = [];
  (values || []).forEach((item) => {
    const cleaned = String(item).trim();
    const key = cleaned.toLowerCase();
    if (!cleaned || cleaned === '-' || seen.has(key)) {
      return;
    }
    seen.add(key);
    options.push({ value: cleaned, label: cleaned });
  });
  return options;
}

export function findStateFromGstPortal(stcd, states) {
  if (!stcd) {
    return null;
  }
  const stcdLower = String(stcd).toLowerCase();
  return (states || []).find((state) => {
    const stateLabel = state.value.split('(')[0].trim().toLowerCase();
    return state.value.slice(0, 3).toLowerCase() === String(stcd).slice(0, 3).toLowerCase()
      || stcdLower === stateLabel
      || stcdLower.includes(stateLabel)
      || stateLabel.includes(stcdLower);
  });
}

export function mapGstPortalCustomerFields(result) {
  const addr = result?.pradr?.addr || {};
  return {
    name: result?.tradeNam || result?.lgnm || '',
    address_1: addr.st || '',
    address_2: addr.loc || '',
    address_3: addr.dst || '',
    pincode: addr.pncd || '',
    gst_status: result?.sts || '',
    registration_type: result?.dty || '',
    stcd: addr.stcd || '',
  };
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatGstReturnPeriod(retPrd) {
  const raw = String(retPrd || '');
  if (!/^\d{6}$/.test(raw)) {
    return raw || '-';
  }
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[Number(raw.slice(0, 2)) - 1] || raw.slice(0, 2);
  return `${month} ${raw.slice(2)}`;
}

/** Sort key for GST return period MMYYYY → YYYYMM number (0 if invalid). */
function gstReturnPeriodSortKey(retPrd) {
  const raw = String(retPrd || '');
  if (!/^\d{6}$/.test(raw)) {
    return 0;
  }
  return Number(raw.slice(2) + raw.slice(0, 2));
}

/** Sort key for Filed On date DD-MM-YYYY → YYYYMMDD number (0 if invalid). */
function gstFiledOnSortKey(dof) {
  const raw = String(dof || '').trim();
  const match = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!match) {
    return 0;
  }
  return Number(`${match[3]}${match[2]}${match[1]}`);
}

function formatAddressBlock(addr) {
  if (!addr || typeof addr !== 'object') {
    return '';
  }
  return [addr.bno, addr.bnm, addr.st, addr.loc, addr.dst, addr.stcd, addr.pncd]
    .filter(Boolean)
    .join(', ');
}

function buildGstDetailRows(result) {
  const addr = result?.pradr?.addr || {};
  const nature = Array.isArray(result?.nba) ? result.nba.join(', ') : (result?.nba || '');
  return [
    ['GSTIN', result?.gstin],
    ['Legal Name', result?.lgnm],
    ['Trade Name', result?.tradeNam],
    ['Registration Type', result?.dty],
    ['GST Status', result?.sts],
    ['Registration Date', result?.rgdt],
    ['Cancellation Date', result?.cxdt],
    ['Constitution', result?.ctb],
    ['Taxpayer Type', result?.ctj || result?.ctjCd],
    ['E-Invoice Status', result?.einvoiceStatus || result?.einvStatus],
    ['Nature of Business', nature],
    ['Address', formatAddressBlock(addr) || result?.pradr?.adr],
  ].filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== '');
}

function buildGstReturnsHtml(returnsPayload) {
  const filings = Array.isArray(returnsPayload?.filings) ? returnsPayload.filings : [];
  if (!filings.length) {
    const message = returnsPayload?.message || 'Return filing history not available for this GSTIN.';
    return `<p style="margin:8px 0 0;color:#6b7280;font-size:12px;">${escapeHtml(message)}</p>`;
  }

  // Latest first: Filed On date, then return period (year+month).
  const sorted = [...filings].sort((a, b) => {
    const filedDiff = gstFiledOnSortKey(b.dof) - gstFiledOnSortKey(a.dof);
    if (filedDiff !== 0) {
      return filedDiff;
    }
    return gstReturnPeriodSortKey(b.ret_prd) - gstReturnPeriodSortKey(a.ret_prd);
  });
  const rows = sorted.slice(0, 24).map((item) => `
    <tr>
      <td style="padding:4px 6px;border:1px solid #e5e7eb;">${escapeHtml(item.rtntype || '-')}</td>
      <td style="padding:4px 6px;border:1px solid #e5e7eb;">${escapeHtml(formatGstReturnPeriod(item.ret_prd))}</td>
      <td style="padding:4px 6px;border:1px solid #e5e7eb;">${escapeHtml(item.status || '-')}</td>
      <td style="padding:4px 6px;border:1px solid #e5e7eb;">${escapeHtml(item.dof || '-')}</td>
      <td style="padding:4px 6px;border:1px solid #e5e7eb;">${escapeHtml(item.arn || '-')}</td>
    </tr>
  `).join('');

  const moreNote = filings.length > 24
    ? `<p style="margin:6px 0 0;color:#6b7280;font-size:11px;">Showing latest 24 of ${filings.length} filings.</p>`
    : '';

  return `
    <div style="max-height:220px;overflow:auto;margin-top:6px;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr style="background:#f3f4f6;">
            <th style="padding:4px 6px;border:1px solid #e5e7eb;text-align:left;">Return</th>
            <th style="padding:4px 6px;border:1px solid #e5e7eb;text-align:left;">Period</th>
            <th style="padding:4px 6px;border:1px solid #e5e7eb;text-align:left;">Status</th>
            <th style="padding:4px 6px;border:1px solid #e5e7eb;text-align:left;">Filed On</th>
            <th style="padding:4px 6px;border:1px solid #e5e7eb;text-align:left;">ARN</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
    ${moreNote}
  `;
}

export function buildGstConfirmHtml(result, returnsPayload) {
  const detailRows = buildGstDetailRows(result).map(([label, value]) => `
    <tr>
      <td style="padding:4px 8px;border:1px solid #e5e7eb;width:34%;font-weight:600;background:#f9fafb;">${escapeHtml(label)}</td>
      <td style="padding:4px 8px;border:1px solid #e5e7eb;text-align:left;">${escapeHtml(value)}</td>
    </tr>
  `).join('');

  return `
    <div style="text-align:left;font-size:13px;">
      <p style="margin:0 0 8px;">Confirm and apply these GST portal details to the customer?</p>
      <table style="width:100%;border-collapse:collapse;margin-bottom:10px;">${detailRows}</table>
      <div style="font-weight:600;margin-top:4px;">GST Return Filings (recent FYs)</div>
      ${buildGstReturnsHtml(returnsPayload)}
    </div>
  `;
}

/**
 * Show GST portal details + return history for confirmation.
 * Resolves true when user confirms (apply autofill), false when cancelled.
 */
export function confirmGstPortalDetails(data) {
  const result = data?.result || {};
  return Swal.fire({
    title: 'Confirm GST Details',
    html: buildGstConfirmHtml(result, data?.returns),
    width: 720,
    showCancelButton: true,
    confirmButtonText: 'Yes, apply details',
    cancelButtonText: 'No, discard',
    focusConfirm: false,
  }).then((response) => Boolean(response.isConfirmed));
}
